import logoLightMode from '../../assets/images/logo-light-mode.svg';
import PrimaryButton from '../../components/common/button/PrimaryButton';
import { useNavigate } from 'react-router-dom';


export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className='vh-100 d-flex flex-column user-select-none align-items-center justify-content-center text-center'>
      <p className="not-found-bg">404</p>
      <img src={logoLightMode} alt="Cypherleak" />
      <h1 className='display-3 fw-bold text-dark mt-3'>Page not found</h1>
      <h4 className='fw-light text-dark text-wrap text-md'>The page you were looking for does not exist</h4>
      <PrimaryButton rest={{ className: 'px-5 py-2 mt-3', onClick: () => navigate('/') }}>
        <span className='h6 my-2 fw-normal'> Go Home </span>
      </PrimaryButton>
    </div>
  );
}
  